import { TextElements } from 'types';
import { valueLogger } from 'utils';
import { StandardBaseManager, ILoader } from './standard';

export interface ILoaderTextElements extends ILoader {
  loadTextElements: () => Promise<TextElements>,
}

export class TextElementsBaseManager extends StandardBaseManager {
  protected loader!: ILoaderTextElements;
  public textElements: TextElements = {};

  public init(loader: ILoaderTextElements) {
    this.loader = loader;
  }

  public async loadTextElements() {
    const elements = await this.loader.loadTextElements();
    this.textElements = elements;
    valueLogger('base', 'text elements loaded', { elements });

    return this.textElements;
  }
}
